import { useState } from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";

function Login({ handleCustomLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const email = username;
      await handleCustomLogin({ email, password });
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Login failed. Please try again.";

      setError(errorMessage);
      console.error("Login failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <div className="bg-white w-[78%] h-[75%] shadow-lg rounded-lg grid grid-cols-2">

        {/* LEFT SIDE */}
        <div className="flex flex-col justify-center items-center bg-blue-100 rounded-l-lg">
          <img
            src="./ATS_LOGO.jpg"
            alt="ATS logo"
            className="w-[150px] h-[150px] object-cover rounded-full"
          />
          <p className="mt-4 text-lg font-semibold text-gray-800 text-center px-3">
            Welcome to ATS Portal
          </p>
        </div>

        {/* RIGHT SIDE */}
        <div className="p-6 flex flex-col justify-center">
          <h1 className="text-4xl font-bold mb-8 text-center text-gray-800">
            Login
          </h1>

          {error && (
            <Alert severity="error" className="mb-4" onClose={() => setError("")}>
              {error}
            </Alert>
          )}

          <form onSubmit={onSubmit} className="flex flex-col">

            <input
              type="email"
              placeholder="Email"
              className="mb-3 p-2 w-full border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={isLoading}
              required
            />

            <input
              type="password"
              placeholder="Password"
              className="mb-3 p-2 w-full border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
              required
            />

            <Button
              variant="contained"
              type="submit"
              disabled={isLoading || !username || !password}
              startIcon={
                isLoading ? <CircularProgress size={20} color="inherit" /> : null
              }
            >
              {isLoading ? "Logging in..." : "Login"}
            </Button>

          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;